module.exports = __webpack_public_path__ + "static/media/49.7e39fe25.png";